import React, { useState, useRef } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { streamTrafikQuote } from '../services/onlineTrafikService';
import Footer from '../components/Footer';

// Şirket logoları
const companyLogos = {
  Allianz: '/images/companies/allianz.jpg',
  Axa: '/images/companies/axa.jpg',
  Anadolu: '/images/companies/anadolu.jpg',
  Ak: '/images/companies/ak.jpg',
  Doga: '/images/companies/doga.jpg',
  HDI: '/images/companies/hdi.jpg',
  Mapfre: '/images/companies/mapfre.jpg',
  Neova: '/images/companies/neova.jpg',
  Ray: '/images/companies/ray.jpg',
  Magdeburger: '/images/companies/magdeburger.jpg',
  Turkiye: '/images/companies/turkiye.jpg',
  'Turkiye Sigorta': '/images/companies/turkiye.jpg',
  'Ana Sigorta': '/images/companies/anasigorta.jpg',
  Atlas: '/images/companies/atlas.png',
  EMA: '/images/companies/ema.png',
  Hepiyi: '/images/companies/hepiyi.jpg',
  'Turkiye Katilim': '/images/companies/turkiyekatilim.jpg',
  Sompo: '/images/companies/sompo.jpg',
  Referans: '/images/companies/referans.png',
  Corpus: '/images/companies/corpus.png',
  Ankara: '/images/companies/ankara.jpg',
  Koru: '/images/companies/koru.jpg',
  Quick: '/images/companies/quick.jpg',
};

const OnlineTrafikSigortasi = () => {
  // Adım yönetimi
  const [step, setStep] = useState(1);

  const [formData, setFormData] = useState({
    tcNo: '',
    phone: '',
    birthDate: '',
    plate: '',
    belgeSeri: '',
    belgeNo: ''
  });

  const [loading, setLoading] = useState(false);
  const [quotes, setQuotes] = useState([]);
  const [systemMessage, setSystemMessage] = useState('');
  const [error, setError] = useState('');
  const [completed, setCompleted] = useState(false);
  const [customerInfo, setCustomerInfo] = useState({ name: null, tc: null, vehicle: null });
  const [totalCompanies, setTotalCompanies] = useState(null);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [hasActivePolicy, setHasActivePolicy] = useState(false);
  const [policyEndDate, setPolicyEndDate] = useState(null);

  const quotesRef = useRef([]);
  const cancelRef = useRef(null);

  // Input handlers
  const handleTcChange = (e) => {
    const value = e.target.value.replace(/\D/g, '').slice(0, 11);
    setFormData(prev => ({ ...prev, tcNo: value }));
    if (error) setError('');
  };

  const handlePhoneChange = (e) => {
    const raw = e.target.value.replace(/\D/g, '').slice(0, 10);
    setFormData(prev => ({ ...prev, phone: raw }));
    if (error) setError('');
  };

  const handlePlateChange = (e) => {
    const value = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 10);
    setFormData(prev => ({ ...prev, plate: value }));
    if (error) setError('');
  };

  const handleBelgeSeriChange = (e) => {
    const value = e.target.value.toUpperCase().replace(/[^A-Z]/g, '').slice(0, 3);
    setFormData(prev => ({ ...prev, belgeSeri: value }));
    if (error) setError('');
  };

  const handleBelgeNoChange = (e) => {
    const value = e.target.value.replace(/\D/g, '').slice(0, 8);
    setFormData(prev => ({ ...prev, belgeNo: value }));
    if (error) setError('');
  };

  // Telefon formatla (görüntü için)
  const formatPhone = (val) => {
    if (!val) return '';
    if (val.length <= 3) return val;
    if (val.length <= 6) return `${val.slice(0, 3)} ${val.slice(3)}`;
    return `${val.slice(0, 3)} ${val.slice(3, 6)} ${val.slice(6)}`;
  };

  // Adım 1 → 2
  const handleStep1 = (e) => {
    e.preventDefault();
    if (formData.tcNo.length !== 11) {
      setError('TC Kimlik No 11 haneli olmalıdır');
      return;
    }
    if (!formData.birthDate) {
      setError('Doğum tarihi gereklidir');
      return;
    }
    if (formData.phone.length < 10) {
      setError('Geçerli bir telefon numarası giriniz');
      return;
    }
    setError('');
    setStep(2);
  };

  // Adım 2 → 3
  const handleStep2 = (e) => {
    e.preventDefault();
    if (!formData.plate || formData.plate.length < 5) {
      setError('Geçerli bir plaka giriniz');
      return;
    }
    setError('');
    setStep(3);
  };

  // Adım 3 → Sorgula
  const handleStep3 = (e) => {
    e.preventDefault();
    if (!formData.belgeSeri) {
      setError('Belge seri harflerini giriniz');
      return;
    }
    if (!formData.belgeNo || formData.belgeNo.length < 4) {
      setError('Belge numarasını giriniz');
      return;
    }
    setError('');
    startQuery();
  };

  const startQuery = () => {
    setLoading(true);
    setQuotes([]);
    setSystemMessage('');
    setCompleted(false);
    setCustomerInfo({ name: null, tc: null, vehicle: null });
    setTotalCompanies(null);
    setPdfUrl(null);
    setHasActivePolicy(false);
    setPolicyEndDate(null);
    quotesRef.current = [];
    setStep(4);

    if (cancelRef.current) cancelRef.current();

    const registrySerialNo = formData.belgeSeri + formData.belgeNo;

    const queryData = {
      tcNo: formData.tcNo,
      plate: formData.plate,
      registrySerialNo: registrySerialNo,
      birthDate: formData.birthDate,
      phone: formData.phone
    };

    cancelRef.current = streamTrafikQuote(
      queryData,
      (data) => {
        if (data.customerName) setCustomerInfo(prev => ({ ...prev, name: data.customerName }));
        if (data.customerTC) setCustomerInfo(prev => ({ ...prev, tc: data.customerTC }));
        if (data.vehicleInfo) setCustomerInfo(prev => ({ ...prev, vehicle: data.vehicleInfo }));
        if (data.totalCompanies) setTotalCompanies(data.totalCompanies);
        if (data.pdfUrl) setPdfUrl(data.pdfUrl);
        if (data.hasActivePolicy) setHasActivePolicy(true);
        if (data.policyEndDate) setPolicyEndDate(data.policyEndDate);

        if (!data.quote) return;
        if (data.quote.companyCode === 'SYSTEM') {
          setSystemMessage(data.quote.message);
          return;
        }

        setQuotes(prev => {
          const existing = prev.findIndex(q => q.companyCode === data.quote.companyCode);
          let newQuotes;
          if (existing >= 0) {
            newQuotes = [...prev];
            newQuotes[existing] = data.quote;
          } else {
            newQuotes = [...prev, data.quote];
          }
          quotesRef.current = newQuotes;
          return newQuotes;
        });
      },
      (err) => {
        setError(typeof err === 'string' ? err : err.message || 'Bir hata oluştu');
        setLoading(false);
      },
      () => {
        setLoading(false);
        setCompleted(true);
      }
    );
  };

  const handleNewQuery = () => {
    setStep(1);
    setFormData({ tcNo: '', phone: '', birthDate: '', plate: '', belgeSeri: '', belgeNo: '' });
    setQuotes([]);
    setError('');
    setCompleted(false);
    setCustomerInfo({ name: null, tc: null, vehicle: null });
    setSystemMessage('');
    setHasActivePolicy(false);
    setPolicyEndDate(null);
    setPdfUrl(null);
    setTotalCompanies(null);
  };

  const formatPrice = (price) => {
    if (!price) return null;
    return new Intl.NumberFormat('tr-TR', {
      style: 'currency',
      currency: 'TRY',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(price);
  };

  const sortedQuotes = [...quotes].sort((a, b) => {
    if (!a.premium && !b.premium) return 0;
    if (!a.premium) return 1;
    if (!b.premium) return -1;
    return a.premium - b.premium;
  });

  const successQuotes = sortedQuotes.filter(q => q.premium && q.status !== 'error');
  const failedQuotes = sortedQuotes.filter(q => !q.premium || q.status === 'error');
  const getCompanyLogo = (code) => companyLogos[code] || null;

  // ─── STEP INDICATOR ───
  const StepIndicator = () => (
    <div className="flex items-center justify-center gap-2 mb-6">
      {[1, 2, 3].map((s) => (
        <React.Fragment key={s}>
          <div className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold transition-all
            ${step >= s
              ? 'bg-blue-600 text-white shadow-md'
              : 'bg-gray-200 text-gray-400'
            }
            ${step === s ? 'ring-4 ring-blue-100 scale-110' : ''}
          `}>
            {step > s ? '✓' : s}
          </div>
          {s < 3 && (
            <div className={`w-12 h-1 rounded-full transition-all ${step > s ? 'bg-blue-600' : 'bg-gray-200'}`} />
          )}
        </React.Fragment>
      ))}
    </div>
  );

  // ─── SOL PANEL (BİLGİ/REKLAM) ───
  const InfoPanel = () => (
    <div className="hidden lg:block">
      <div className="sticky top-24">
        {/* Ana Başlık */}
        <div className="bg-gradient-to-br from-blue-600 to-blue-800 rounded-2xl p-6 text-white mb-4 shadow-xl">
          <h2 className="text-xl font-bold mb-2">Trafik Sigortanızı Online Yapın</h2>
          <p className="text-blue-100 text-sm leading-relaxed">
            Sadece 30 saniyede 20'den fazla sigorta şirketinin fiyatını karşılaştırın.
          </p>
        </div>

        {/* Avantajlar */}
        <div className="bg-white rounded-2xl p-5 shadow-sm border border-gray-100 space-y-4">
          <div className="flex items-start gap-3">
            <div className="w-10 h-10 bg-green-50 rounded-xl flex items-center justify-center flex-shrink-0">
              <svg className="w-5 h-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
            </div>
            <div>
              <h3 className="font-semibold text-gray-800 text-sm">En Uygun Fiyat Garantisi</h3>
              <p className="text-gray-500 text-xs mt-0.5">20+ sigorta şirketinden anlık fiyat karşılaştırması yaparak en ucuz teklifi buluyoruz.</p>
            </div>
          </div>

          <div className="flex items-start gap-3">
            <div className="w-10 h-10 bg-blue-50 rounded-xl flex items-center justify-center flex-shrink-0">
              <svg className="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" /></svg>
            </div>
            <div>
              <h3 className="font-semibold text-gray-800 text-sm">30 Saniyede Sonuç</h3>
              <p className="text-gray-500 text-xs mt-0.5">Bilgilerinizi girin, tüm teklifler saniyeler içinde ekranınızda olsun.</p>
            </div>
          </div>

          <div className="flex items-start gap-3">
            <div className="w-10 h-10 bg-purple-50 rounded-xl flex items-center justify-center flex-shrink-0">
              <svg className="w-5 h-5 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" /></svg>
            </div>
            <div>
              <h3 className="font-semibold text-gray-800 text-sm">Güvenli Ödeme</h3>
              <p className="text-gray-500 text-xs mt-0.5">Beğendiğiniz teklifi seçin, sigorta şirketinin güvenli sayfasından ödemenizi yapın.</p>
            </div>
          </div>

          <div className="flex items-start gap-3">
            <div className="w-10 h-10 bg-amber-50 rounded-xl flex items-center justify-center flex-shrink-0">
              <svg className="w-5 h-5 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" /></svg>
            </div>
            <div>
              <h3 className="font-semibold text-gray-800 text-sm">7/24 Destek</h3>
              <p className="text-gray-500 text-xs mt-0.5">Sorularınız mı var? Uzman ekibimiz her zaman yanınızda.</p>
            </div>
          </div>
        </div>

        {/* Güven rozeti */}
        <div className="mt-4 text-center">
          <p className="text-xs text-gray-400">SigortamOlsun.com güvencesiyle</p>
        </div>
      </div>
    </div>
  );

  // ─── RENDER ───
  return (
    <div className="min-h-screen bg-gray-50">
      <Helmet>
        <title>Online Trafik Sigortası Fiyat Sorgulama | SigortamOlsun</title>
        <meta name="description" content="Online trafik sigortası fiyat sorgulama. 20+ sigorta şirketinden anında teklif alın, karşılaştırın ve en uygun fiyatı bulun." />
        <link rel="canonical" href="https://sigortamolsun.com/online-trafik-sigortasi" />
      </Helmet>

      <div className="max-w-6xl mx-auto px-4 py-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">

          {/* Sol Panel - Bilgi */}
          <div className="lg:col-span-5">
            <InfoPanel />
          </div>

          {/* Sağ Panel - Form/Sonuçlar */}
          <div className="lg:col-span-7">

            {/* ─── ADIM 1: TC + Telefon + Doğum Tarihi ─── */}
            {step === 1 && (
              <div className="max-w-md mx-auto">
                <StepIndicator />

                <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100">
                  <div className="text-center mb-5">
                    <h2 className="text-lg font-bold text-gray-800">Bilgilerinizi Girin</h2>
                    <p className="text-gray-500 text-sm mt-1">Trafik sigortası teklifiniz için bilgilerinizi girin</p>
                  </div>

                  <form onSubmit={handleStep1} className="space-y-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1.5">TC Kimlik Numarası</label>
                      <input
                        type="text"
                        inputMode="numeric"
                        value={formData.tcNo}
                        onChange={handleTcChange}
                        placeholder="TC Kimlik Numaranızı Girin"
                        className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 outline-none text-base"
                        autoFocus
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1.5">Doğum Tarihi</label>
                      <input
                        type="date"
                        value={formData.birthDate}
                        onChange={(e) => { setFormData(prev => ({ ...prev, birthDate: e.target.value })); if (error) setError(''); }}
                        className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 outline-none text-base"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1.5">Telefon Numarası</label>
                      <div className="relative">
                        <span className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 font-medium">+90</span>
                        <input
                          type="tel"
                          value={formatPhone(formData.phone)}
                          onChange={handlePhoneChange}
                          placeholder="5XX XXX XXXX"
                          className="w-full pl-14 pr-4 py-3 rounded-xl border border-gray-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 outline-none text-base tracking-wide"
                        />
                      </div>
                    </div>

                    {error && (
                      <div className="bg-red-50 border border-red-200 rounded-xl p-3 text-sm text-red-600 flex items-center gap-2">
                        <svg className="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" /></svg> {error}
                      </div>
                    )}

                    {/* KVKK */}
                    <div className="flex items-start gap-2 text-xs text-gray-500 pt-1">
                      <input type="checkbox" defaultChecked className="mt-0.5 rounded" />
                      <span>
                        <Link to="/kvkk" className="text-blue-600 hover:underline">KVKK</Link>
                        {' ve '}
                        <Link to="/aydinlatma-metni" className="text-blue-600 hover:underline">kullanım koşullarını</Link>
                        {' kabul ediyorum'}
                      </span>
                    </div>

                    <button
                      type="submit"
                      className="w-full py-3.5 rounded-xl bg-gradient-to-r from-blue-500 to-blue-600 text-white font-semibold text-base shadow-lg hover:shadow-xl hover:from-blue-600 hover:to-blue-700 transition-all active:scale-[0.98]"
                    >
                      Trafik Sigortası Teklif Al →
                    </button>
                  </form>
                </div>

                {/* Mobil bilgi */}
                <div className="lg:hidden mt-6 grid grid-cols-2 gap-3">
                  <div className="bg-white rounded-xl p-3 border border-gray-100 text-center">
                    <p className="text-xs text-gray-600 font-medium">En Uygun Fiyat</p>
                  </div>
                  <div className="bg-white rounded-xl p-3 border border-gray-100 text-center">
                    <p className="text-xs text-gray-600 font-medium">30 Saniyede Sonuç</p>
                  </div>
                  <div className="bg-white rounded-xl p-3 border border-gray-100 text-center">
                    <p className="text-xs text-gray-600 font-medium">Güvenli Ödeme</p>
                  </div>
                  <div className="bg-white rounded-xl p-3 border border-gray-100 text-center">
                    <p className="text-xs text-gray-600 font-medium">7/24 Destek</p>
                  </div>
                </div>
              </div>
            )}

            {/* ─── ADIM 2: Plaka ─── */}
            {step === 2 && (
              <div className="max-w-md mx-auto">
                <StepIndicator />

                <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100">
                  <div className="text-center mb-5">
                    <h2 className="text-lg font-bold text-gray-800">Araç Plakanız</h2>
                    <p className="text-gray-500 text-sm mt-1">Aracınızın plakasını giriniz</p>
                  </div>

                  <form onSubmit={handleStep2} className="space-y-4">
                    <div>
                      <input
                        type="text"
                        value={formData.plate}
                        onChange={handlePlateChange}
                        placeholder="34 ABC 123"
                        className="w-full px-4 py-4 rounded-xl border-2 border-gray-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 outline-none text-2xl text-center font-bold tracking-widest uppercase"
                        autoFocus
                      />
                      <p className="text-xs text-gray-400 mt-2 text-center">Örnek: 34ABC123, 06AB1234</p>
                    </div>

                    {error && (
                      <div className="bg-red-50 border border-red-200 rounded-xl p-3 text-sm text-red-600 flex items-center gap-2">
                        <svg className="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" /></svg> {error}
                      </div>
                    )}

                    <div className="flex gap-3">
                      <button
                        type="button"
                        onClick={() => { setStep(1); setError(''); }}
                        className="px-6 py-3 rounded-xl border border-gray-200 text-gray-600 font-medium hover:bg-gray-50 transition-all"
                      >
                        ← Geri
                      </button>
                      <button
                        type="submit"
                        className="flex-1 py-3 rounded-xl bg-gradient-to-r from-blue-500 to-blue-600 text-white font-semibold shadow-lg hover:shadow-xl hover:from-blue-600 hover:to-blue-700 transition-all active:scale-[0.98]"
                      >
                        Devam →
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            )}

            {/* ─── ADIM 3: Belge Seri + No ─── */}
            {step === 3 && (
              <div className="max-w-md mx-auto">
                <StepIndicator />

                <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100">
                  <div className="text-center mb-5">
                    <p className="text-blue-600 text-sm font-medium mb-2">Bütçenize en uygun trafik sigortasını öğrenmenize son bir adım!</p>
                    <h2 className="text-lg font-bold text-gray-800">Ruhsat Bilgileri</h2>
                    <p className="text-gray-500 text-sm mt-1">Araç ruhsatınızdaki belge seri ve numarasını girin</p>
                  </div>

                  <form onSubmit={handleStep3} className="space-y-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1.5">Belge Seri ve Numarası</label>
                      <div className="flex gap-3">
                        <div className="w-1/3">
                          <input
                            type="text"
                            value={formData.belgeSeri}
                            onChange={handleBelgeSeriChange}
                            placeholder="AA"
                            className="w-full px-3 py-3.5 rounded-xl border-2 border-gray-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 outline-none text-lg text-center font-bold uppercase tracking-widest"
                            autoFocus
                            maxLength={3}
                          />
                          <p className="text-xs text-gray-400 mt-1 text-center">Seri (Harf)</p>
                        </div>
                        <div className="flex-1">
                          <input
                            type="text"
                            inputMode="numeric"
                            value={formData.belgeNo}
                            onChange={handleBelgeNoChange}
                            placeholder="000000"
                            className="w-full px-3 py-3.5 rounded-xl border-2 border-gray-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 outline-none text-lg text-center font-bold tracking-widest"
                            maxLength={8}
                          />
                          <p className="text-xs text-gray-400 mt-1 text-center">Numara (Rakam)</p>
                        </div>
                      </div>
                    </div>

                    {/* Yardım notu */}
                    <div className="bg-blue-50 rounded-xl p-3 flex items-start gap-2">
                      <svg className="w-4 h-4 text-blue-500 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                      <p className="text-xs text-blue-700 leading-relaxed">
                        Belge seri ve numarasını araç ruhsatınızın ön yüzünde bulabilirsiniz. Örnek: <strong>AA 123456</strong>
                      </p>
                    </div>

                    {error && (
                      <div className="bg-red-50 border border-red-200 rounded-xl p-3 text-sm text-red-600 flex items-center gap-2">
                        <svg className="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" /></svg> {error}
                      </div>
                    )}

                    <div className="flex gap-3">
                      <button
                        type="button"
                        onClick={() => { setStep(2); setError(''); }}
                        className="px-6 py-3 rounded-xl border border-gray-200 text-gray-600 font-medium hover:bg-gray-50 transition-all"
                      >
                        ← Geri
                      </button>
                      <button
                        type="submit"
                        className="flex-1 py-3.5 rounded-xl bg-gradient-to-r from-green-500 to-green-600 text-white font-semibold text-base shadow-lg hover:shadow-xl hover:from-green-600 hover:to-green-700 transition-all active:scale-[0.98]"
                      >
                        Fiyatları Öğren
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            )}

            {/* ─── ADIM 4: Sonuçlar ─── */}
            {step === 4 && (
              <div>
                {/* Müşteri Bilgi Kartı */}
                {customerInfo.name && (
                  <div className="bg-gradient-to-r from-blue-500 to-blue-600 rounded-2xl p-4 mb-4 text-white shadow-lg">
                    <div className="flex items-center justify-between">
                      <div>
                        <div className="text-blue-200 text-xs mb-0.5">Araç Sahibi</div>
                        <div className="font-bold text-lg">{customerInfo.name}</div>
                        {customerInfo.vehicle && (
                          <div className="text-blue-100 text-sm mt-0.5">{customerInfo.vehicle}</div>
                        )}
                      </div>
                      <div className="text-right">
                        <div className="text-blue-200 text-xs mb-0.5">Plaka</div>
                        <div className="font-bold text-lg">{formData.plate}</div>
                        {totalCompanies && (
                          <div className="text-blue-100 text-sm mt-0.5">{totalCompanies} şirket sorgulanıyor</div>
                        )}
                      </div>
                    </div>
                  </div>
                )}

                {/* Aktif Poliçe Uyarısı */}
                {hasActivePolicy && (
                  <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 mb-4 flex items-start gap-3">
                    <svg className="w-6 h-6 text-amber-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" /></svg>
                    <div>
                      <div className="font-semibold text-amber-800">Aktif Poliçe Mevcut</div>
                      <p className="text-sm text-amber-700 mt-0.5">
                        Bu araçta aktif bir trafik sigortası poliçesi bulunmaktadır.
                        {policyEndDate && <span> Bitiş tarihi: <strong>{policyEndDate}</strong></span>}
                      </p>
                    </div>
                  </div>
                )}

                {/* Başlık */}
                <div className="flex items-center justify-between mb-4">
                  <h2 className="text-lg font-bold text-gray-800">
                    {loading ? 'Teklifler Yükleniyor...' : `Teklifler ${successQuotes.length > 0 ? `(${successQuotes.length})` : ''}`}
                  </h2>
                  <div className="flex items-center gap-3">
                    {loading && (
                      <div className="flex items-center gap-2 text-sm text-blue-500">
                        <svg className="w-4 h-4 animate-spin" fill="none" viewBox="0 0 24 24">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
                        </svg>
                        Sorgulanıyor...
                      </div>
                    )}
                    {completed && !loading && (
                      <span className="text-sm text-green-600 font-medium">Tamamlandı</span>
                    )}
                    {pdfUrl && (
                      <a href={pdfUrl} target="_blank" rel="noopener noreferrer"
                        className="px-3 py-1.5 bg-blue-500 hover:bg-blue-600 text-white text-sm font-medium rounded-lg transition-colors">
                        PDF İndir
                      </a>
                    )}
                  </div>
                </div>

                {/* System mesajı */}
                {systemMessage && (
                  <div className="bg-blue-50 border border-blue-200 rounded-xl p-3 text-blue-700 text-sm mb-4">
                    {systemMessage}
                  </div>
                )}

                {/* Loading skeleton */}
                {loading && quotes.length === 0 && (
                  <div className="space-y-3">
                    {[1, 2, 3, 4].map(i => (
                      <div key={i} className="bg-white rounded-xl p-4 border border-gray-200 animate-pulse">
                        <div className="flex items-center justify-between">
                          <div className="flex items-center gap-3">
                            <div className="w-12 h-12 bg-gray-200 rounded-lg" />
                            <div>
                              <div className="w-28 h-4 bg-gray-200 rounded mb-2" />
                              <div className="w-16 h-3 bg-gray-100 rounded" />
                            </div>
                          </div>
                          <div className="w-20 h-7 bg-gray-200 rounded" />
                        </div>
                      </div>
                    ))}
                    <p className="text-center text-sm text-gray-400 mt-2">Sigorta şirketlerinden teklifler alınıyor...</p>
                  </div>
                )}

                {/* Başarılı Teklifler */}
                <div className="space-y-3">
                  {successQuotes.map((quote, index) => {
                    const logoSrc = getCompanyLogo(quote.companyCode);
                    return (
                      <div key={quote.companyCode || index}
                        className="bg-white rounded-xl p-4 border border-gray-200 hover:border-green-300 hover:shadow-md transition-all">
                        <div className="flex items-center justify-between">
                          <div className="flex items-center gap-3">
                            <div className="w-12 h-12 rounded-lg bg-white border border-gray-100 flex items-center justify-center overflow-hidden flex-shrink-0">
                              {logoSrc ? (
                                <img src={logoSrc} alt={quote.companyName} className="w-10 h-10 object-contain" />
                              ) : (
                                <span className="text-lg font-bold text-gray-300">{quote.companyName?.charAt(0)}</span>
                              )}
                            </div>
                            <div>
                              <div className="font-semibold text-gray-800">{quote.companyName}</div>
                              <div className="text-xs text-green-500 mt-0.5">Teklif hazır</div>
                            </div>
                          </div>

                          <div className="flex items-center gap-3">
                            <div className="text-right">
                              <div className="text-xl font-bold text-green-600">{formatPrice(quote.premium)}</div>
                              <div className="text-xs text-gray-400">yıllık</div>
                            </div>
                            {quote.paymentUrl && (
                              <a href={quote.paymentUrl} target="_blank" rel="noopener noreferrer"
                                className="px-4 py-2.5 bg-green-500 hover:bg-green-600 text-white text-sm font-semibold rounded-xl transition-all shadow-sm hover:shadow-md active:scale-95">
                                Satın Al
                              </a>
                            )}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>

                {/* Başarısız Teklifler */}
                {failedQuotes.length > 0 && (completed || !loading) && (
                  <div className="mt-6">
                    <details className="group">
                      <summary className="text-sm text-gray-400 cursor-pointer hover:text-gray-600 transition-colors">
                        Teklif alınamayan şirketler ({failedQuotes.length})
                      </summary>
                      <div className="grid grid-cols-2 sm:grid-cols-3 gap-2 mt-3">
                        {failedQuotes.map((quote, index) => {
                          const logoSrc = getCompanyLogo(quote.companyCode);
                          let errorReason = 'Teklif alınamadı';
                          const msg = (quote.message || '').toLowerCase();
                          if (msg.includes('yaşayan poli') || msg.includes('yasayan poli')) errorReason = 'Mevcut poliçe var';
                          else if (msg.includes('timeout') || msg.includes('zaman')) errorReason = 'Zaman aşımı';
                          else if (msg.includes('hata')) errorReason = 'Sistem hatası';

                          return (
                            <div key={quote.companyCode || index} className="bg-white rounded-lg p-2.5 border border-gray-100 opacity-60">
                              <div className="flex items-center gap-2">
                                <div className="w-7 h-7 rounded bg-gray-50 border border-gray-100 flex items-center justify-center overflow-hidden flex-shrink-0">
                                  {logoSrc ? (
                                    <img src={logoSrc} alt={quote.companyName} className="w-5 h-5 object-contain" />
                                  ) : (
                                    <span className="text-xs font-bold text-gray-300">{quote.companyName?.charAt(0)}</span>
                                  )}
                                </div>
                                <div className="min-w-0">
                                  <div className="font-medium text-gray-600 text-xs truncate">{quote.companyName}</div>
                                  <div className="text-xs text-red-400 truncate">{errorReason}</div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </details>
                  </div>
                )}

                {/* Yeni Sorgu */}
                {completed && (
                  <div className="mt-6 text-center">
                    <button
                      onClick={handleNewQuery}
                      className="px-6 py-2.5 rounded-xl border border-gray-200 text-gray-600 font-medium hover:bg-gray-50 transition-all"
                    >
                      ← Yeni Sorgu Yap
                    </button>
                  </div>
                )}
              </div>
            )}

          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default OnlineTrafikSigortasi;